var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { generateUUID, getLanguageFromStorage } from 'syf-js-utilities';
import useWindowSize from 'syf-component-library/ui/customHooks/useWindowWidth';
import { useRewardsConfigContext } from '../../../../../context/rewardsConfig';
import getClientImgSrc from '../../../../../helpers/imageUtils';
import useRewards from '../../../../../hooks/useRewards';
import PropositionsCard from '../PropositionCard';
import RewardsCarousel from '../RewardsCarousel';
import { CardsContainer, ClientImage, TextContent, Title, ValuePropositionContainer } from './subcomponents';
var clientData = {
    propositions: []
};
var ValueProposition = function () {
    var _a, _b, _c, _d, _e, _f, _g;
    var t = useTranslation().t;
    var language = getLanguageFromStorage();
    var config = useRewardsConfigContext().config;
    var isLessThanDesktop = useWindowSize().isLessThanDesktop;
    var _h = useRewards(), cardType = _h.cardType, clientId = _h.clientId, rewardsExperience = _h.rewardsExperience;
    var _j = __assign({}, clientData), disclaimer = _j.disclaimer, propositions = _j.propositions, valuePropImg = _j.valuePropImg;
    if ((_b = (_a = rewardsExperience === null || rewardsExperience === void 0 ? void 0 : rewardsExperience[clientId]) === null || _a === void 0 ? void 0 : _a[cardType]) === null || _b === void 0 ? void 0 : _b[language]) {
        disclaimer = (_d = (_c = rewardsExperience[clientId][cardType]) === null || _c === void 0 ? void 0 : _c[language]) === null || _d === void 0 ? void 0 : _d.disclaimer;
        propositions = (_f = (_e = rewardsExperience[clientId][cardType]) === null || _e === void 0 ? void 0 : _e[language]) === null || _f === void 0 ? void 0 : _f.propositions;
        valuePropImg = (_g = rewardsExperience[clientId][cardType]) === null || _g === void 0 ? void 0 : _g.valuePropImg;
    }
    var howToEarnPointsHeader = rewardsExperience === null || rewardsExperience === void 0 ? void 0 : rewardsExperience[clientId].howToEarnPointsHeader;
    var lastIndex = propositions.length - 1;
    var isDivisibleByThree = propositions.length % 3 === 1;
    return (_jsxs(ValuePropositionContainer, __assign({ "data-testid": "cards-value-proposition" }, { children: [_jsx(Title, { children: t(howToEarnPointsHeader) }), isLessThanDesktop && propositions.length > 2 ? (_jsx(RewardsCarousel, { propositions: propositions })) : (_jsxs(CardsContainer, { children: [propositions.map(function (element, index) {
                        var isFullWidthProposition = index === lastIndex && isDivisibleByThree;
                        return (_jsx(PropositionsCard, { heading: element.heading, points: element.points, description: element.description, isFullWidthProposition: isFullWidthProposition }, "propositions-desktop-".concat(generateUUID())));
                    }), valuePropImg && (_jsx(ClientImage, { src: getClientImgSrc({
                            config: config,
                            client: clientId,
                            image: valuePropImg
                        }), alt: "".concat(clientId, " value proposition") }))] })), disclaimer && _jsx(TextContent, { children: disclaimer })] })));
};
export default ValueProposition;
